


import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XImg from 'vux/src/components/x-img/index.vue'


import getLocation from "@/components/getLocation";

import detailPop from "@/components/detailPop";
export default {
directives: {
TransferDom
},

components: {
getLocation,
XImg,
detailPop
},
data() {

return {

isDetailPopShow: false, //名宿等详情弹窗
details: {
imgList: [],
title: "",
address: "",
des: "",
mobile: "",
lat: "",
lng: "",
is_guide: false,
id: ""
},


plateId: this.$route.query.plateId,
mapObj: null, //地图实例
geocoder: null, //地理/逆地理编码插件
isLocation: false, //是否展示当前定位了
scenicBound: [], //景区电子围栏范围
mapMaxZoom: 18, //地图最大层级
mapMinZoom: 5, //地图最小层级
mapLat: 30.244132,
mapLng: 120.147476,
leLayer: null, //瓦片
areaList: null,
adCode: 3300, //高德的adCode 浙江省3300 用于是否要切换景区时做判断

dataList: null,
curMarkerArr: [],
isBarShow: false,
provinceMarkers: [], //省级聚合点
citysMarkers: [],
cityPolygons: [], //市级行政区域范围
moveStartZoom: null, //平移开始时的地图层级
moveEndZoom: null 
};
},

computed: {},

watch: {
adCode(newV) {
let i;
if (newV == "3300") {
i = 0;
} else {
for (let j in this.areaList) {
if (newV == this.areaList[j].adCode) {
i = parseInt(j) + 1;
break;
}
}
}
console.log("iiiiiiiiiiiii=" + i);

this.scrollLeftTo(
document.getElementsByClassName("bar-item")[i],
document.getElementById("barBox"),
i
);

}
},

methods: {

getMap() {
let that = this;

that.mapObj = new AMap.Map("container", {
view: new AMap.View2D({

center: new AMap.LngLat(that.mapLng, that.mapLat),
zoom: 7, //设置地图缩放级别
rotation: 0 
}),
resizeEnable: true,
zooms: [that.mapMinZoom, that.mapMaxZoom],
features: ["bg", "road", "building"],
lang: "zh_cn" 
});
that.curMarkerArr = that.provinceMarkers;
that.mapObj.add(that.curMarkerArr); 

that.isLocation = true; 
that.mapObj.on("complete", function() {});

that.leLayer = new AMap.TileLayer({

tileUrl:
"https://pic2.worldmaipu.com/api/v1/tile!GetBlodTile.action?x=[x]&z=[z]&y=[y]",
zIndex: 2
});
that.leLayer.setMap(that.mapObj);

AMap.event.addListener(that.mapObj, "zoomend", function() {
console.log("当前地图层级==" + that.mapObj.getZoom());
});

AMap.event.addListener(that.mapObj, "movestart", function() {
that.moveStartZoom = that.mapObj.getZoom();
console.log("moveStart............zoom:" + that.moveStartZoom);
});

AMap.event.addListener(that.mapObj, "moveend", function() {
that.moveEndZoom = that.mapObj.getZoom();
console.log("moveEnd............zoom:" + that.moveEndZoom);
that.geocoder.getAddress(
[that.mapObj.getCenter().lng, that.mapObj.getCenter().lat],
function(status, result) {
if (status === "complete" && result.info === "OK") {

console.log(result);

let cityCode = result.regeocode.addressComponent.adcode.substring(
0,
4
);
console.log(cityCode + "..." + that.adCode);
if (that.moveEndZoom != that.moveStartZoom) {

console.log("平移后缩放了");
that.zoomAndMove(cityCode);
} else {

console.log("平移后没缩放");
that.justMove(cityCode);
}

if (that.mapObj.getZoom() < 9) {

that.mapObj.remove(that.cityPolygons);
} else {

if (cityCode.substring(0, 2) == "33") {
AMap.plugin("AMap.DistrictSearch", function() {

let district = new AMap.DistrictSearch({

extensions: "all",

level: "city"
});

district.search(
result.regeocode.addressComponent.citycode,
function(status, result) {

let bounds = result.districtList[0].boundaries;
that.mapObj.remove(that.cityPolygons);
that.cityPolygons = [];
if (bounds) {
for (let i = 0, l = bounds.length; i < l; i++) {

let polygon = new AMap.Polygon({
map: that.mapObj,
strokeWeight: 2,
path: bounds[i],
fillOpacity: 0,

strokeColor: "#48636e"
});
that.cityPolygons.push(polygon);
}


}
}
);
});
}
}
}
}
);


});














that.mapObj.plugin("AMap.Geocoder", function() {
that.geocoder = new AMap.Geocoder({

city: "浙江省",
extensions: "base"
});

});
},

getCityAndTags() {
let that = this;
that.get({
url: that.GLOBAL.BASE_URL + "/api/v1/index!getSpecialFilter.action",
params: {
type: that.plateId
},
isShowLoading: false,
success: function(data) {
console.log(data.data.data);
that.areaList = data.data.data.areaList;
that.citysId = data.data.data.areaList[0].id;
that.getData(that.citysId);
}
});
},
getData() {
let that = this;
that.get({
url: that.GLOBAL.BASE_URL + "/api/v1/index!getSpecialData.action",
params: {
type: that.plateId,
area_id: that.citysId,
tag_id: -1
},
isShowLoading: false,
success: function(data) {
console.log(data.data.data);
that.dataList = data.data.data.specialList;
that.mapObj.remove(that.curMarkerArr);
that.curMarkerArr = [];
if (that.dataList.length == 0) {
that.$vux.toast.text("暂无数据", "middle");
} else {
that.setMarker(that.dataList);
that.mapObj.add(that.curMarkerArr);

}
}
});
},
setMarker(points) {
let that = this;
for (let i in points) {
let marker = new AMap.Marker({
position: new AMap.LngLat(
points[i].longitude_gcj,
points[i].latitude_gcj
),

content: `<div class='citys-poi'><div class='ua_poi'></div><span class='ua_poi_name'>${points[i].name}</span></div>`,

offset: new AMap.Pixel(-16, -32),
extData: {
id: points[i].id
}
});
AMap.event.addListener(marker, "click", function(e) {
let position = e.target.getPosition();
let extData = e.target.getExtData();
this.setTop(true);
console.log(extData);


that.getDetail(extData.id);


});
let min = points[i].min_zoom - 9;
for (let z = 0; z < that.mapMaxZoom - 9 + 1; z++) {
if (z >= min) {
that.citysMarkers[z].push(marker);
}
}
}
console.log(that.citysMarkers);
},

changeDetailPop(val) {
this.isDetailPopShow = val;
if (val == false) {
this.details = {
imgList: [],
title: "",
address: "",
des: "",
mobile: "",
lat: "",
lng: "",
is_guide: false,
id: ""
}; //清空详情组件的details props
}
},
changeCity(adCode, lat, lng) {
if (this.adCode == adCode) {
return;
} else {

if (adCode == "3300") {
this.adCode = "3300";
if (this.mapObj.getZoom() < 9) {
} else {
this.mapObj.setZoom(7);
}

this.mapObj.remove(this.cityPolygons);

this.mapObj.remove(this.curMarkerArr);
this.curMarkerArr = this.provinceMarkers;
this.mapObj.add(this.curMarkerArr);
} else {
this.mapObj.setCenter([lng, lat]);
if (this.mapObj.getZoom() < 9) {
this.adCode = adCode;
this.getDatas(this.adCode);
}
}
}
},


getDatas(adCode) {
let that = this;
that.get({
url: that.GLOBAL.BASE_URL + "/api/v1/map_view!getFood.action",
params: {
adCode: adCode
},
isShowLoading: false,
success: function(data) {
console.log(data.data.data);
that.dataList = data.data.data.foodList;
if (that.areaList == null) {

that.areaList = data.data.data.areaList;
for (let i in that.areaList) {
let marker = new AMap.Marker({

content:
"<div class='province-poi'><div class='aggregate-bg'></div><span class='aggregate-name'><span>" +
that.areaList[i].name +
"</span><i>" +
that.areaList[i].counts +
"</i>" +
"</span></div>",
position: new AMap.LngLat(
that.areaList[i].longitude_gcj,
that.areaList[i].latitude_gcj
),

offset: new AMap.Pixel(-10, -32), //中心点



extData: {
citysId: that.areaList[i].id
}
});
AMap.event.addListener(marker, "click", function(e) {
let position = e.target.getPosition();
let extData = e.target.getExtData();
this.setTop(true);
console.log(extData);
that.citysId = extData.citysId;

that.mapObj.setZoomAndCenter(9, position);
});
that.provinceMarkers.push(marker);
}
} else {
}

if (that.mapObj == null) {

that.getMap();
} else {

}


if (that.mapObj.getZoom() > 8) {
that.citysMarkers = [];
for (let j = 9; j < that.mapMaxZoom + 1; j++) {
that.citysMarkers.push([]);
}
that.setMarker(that.dataList);
that.mapObj.remove(that.curMarkerArr);
that.curMarkerArr = that.citysMarkers[that.mapObj.getZoom() - 9];
that.mapObj.add(that.curMarkerArr);
}
}
});
},

getDetail(id) {
let that = this;
that.get({
url: that.GLOBAL.BASE_URL + "/api/v1/map_view!detail.action",
params: { hid: id },
isShowLoading: false,
success: function(data) {
console.log(data.data.data);
let details = {};
details.is_guide = 0;
details.id = data.data.data.hotspot.id;
details.imgList = [];
if (data.data.data.imgList.length != 0) {
for (let i in data.data.data.imgList) {
details.imgList.push(
that.GLOBAL.DOMAIN_URL + data.data.data.imgList[i].midImg
);
}
} else {
if (data.data.data.hotspot.thumbImg.indexOf("http") != -1) {
details.imgList.push(data.data.data.hotspot.thumbImg);
} else {
details.imgList.push(
that.GLOBAL.DOMAIN_URL + data.data.data.hotspot.thumbImg
);
}
}


details.title = data.data.data.hotspot.name;
details.address = data.data.data.hotspot.address;
details.des = data.data.data.hotspot.description;
details.mobile = "";
details.lat = data.data.data.hotspot.latitudeGCJ + "";
details.lng = data.data.data.hotspot.longitudeGCJ + "";
if (data.data.data.hotspot.audio != null) {
details.audio =
that.GLOBAL.DOMAIN_URL +
data.data.data.hotspot.audio.split(".")[0] +
".mp3";
}

that.details = details;
that.isDetailPopShow = true;
}
});
},

justMove(cityCode) {
let that = this;
if (cityCode.substring(0, 2) == "33") {

console.log("浙江省内");

if (that.mapObj.getZoom() < 9) {



return;
} else {
if (cityCode == that.adCode) {

return;
} else {

that.adCode = cityCode;
that.getDatas(that.adCode);
}
}
} else {
console.log("浙江省外");

return;
}
},

zoomAndMove(cityCode) {
let that = this;
let zoom = that.mapObj.getZoom();
if (cityCode.substring(0, 2) == "33") {

console.log("浙江省内");
if (zoom < 9) {
that.adCode = "3300";

that.mapObj.remove(that.curMarkerArr);
that.curMarkerArr = that.provinceMarkers;
that.mapObj.add(that.curMarkerArr);
} else {
if (cityCode == that.adCode) {

that.mapObj.remove(that.curMarkerArr);
that.curMarkerArr = that.citysMarkers[zoom - 9];
that.mapObj.add(that.curMarkerArr);
} else {

that.adCode = cityCode;
that.getDatas(that.adCode);
}
}
} else {

console.log("浙江省外");
return;
}
},


scrollLeftTo(element, elementFather, index) {
let actualLeft = element.offsetLeft;
let current = element.offsetParent;
actualLeft += current.offsetLeft;
current = current.offsetParent;
elementFather.scrollLeft = actualLeft - element.clientWidth * 1;
}
},

created() {
document.title = "百县千碗";

this.getDatas(this.adCode);
},

mounted() {

},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};



// WEBPACK FOOTER //
// ./src/pages/bxqw.vue